import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey('52b7d53d1e94dcf48fec4a8428c6b501Tz05NTk1NCxFPTE3NTUwNDgwMjIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==');
